<template>
  <default-layout>
    <nuxt />
  </default-layout>
</template>

<script>
  import CriticalErrorModal from '~/components/critical-error-modal'
  import DefaultLayout from '~/layouts/default'

  export default {
    components: {
      CriticalErrorModal,
      DefaultLayout
    }
  }
</script>

<style lang="scss">
  .booking {
    main.body {
      display: flex;
      justify-content: center;
      padding: $space-060;
    }

    section.content {
      padding: $space-050;
      width: 100%;

      @include tablet {
        max-width: $media-query-tablet;
        padding: $space-050 $space-110;
      }

      h1 {
        @include font('090');
        text-transform: capitalize;
        margin-bottom: $space-070;
      }
    }

    h3 {
      @include font('080');
      margin-bottom: $space-030;
    }

    dl, dt, dd {
      margin: 0;
    }

  .list-wrapper {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin: $space-050 0;

    dl {
      max-width: 50%;

      dd {
        margin-bottom: $space-070;
        text-transform: capitalize;

        p {
          margin: 0;
        }
      }
    }

    &__right-align {
      text-align: right;
    }
  }
  
  .booking-block {
    padding-bottom: $space-090;
    width: 100%;

    &__container {
      display: flex;
      flex-direction: column;
      @include tablet {
        flex-direction: row;
      }

      p {
        margin-bottom: $space-015;
        &:last-child {
          margin-bottom: 0;
        }
      }

      dl,
      p {
        margin: $space-060 $space-050;

        @include breakpoint(medium) {
          width: 100%;
          margin-right: $space-060;
        }

        dt {
          @include font("040");
          margin-bottom: $space-030;
        }

        dd {
          @include font("060");
        }
      }
    }

    &__table {
      margin: $d-small 0 $d-x-small;

      @include tablet {
        width: 100%;
        margin-right: $space-060;
      }

      p:last-child {
        margin-bottom: $space-015;
      }
    }

    &__cta {
      margin: auto auto auto 0;
      text-align: center;
      @include tablet {
        margin: auto 0 auto auto;
        width: 55%;
      }
    }

    &__checkbox { 
      span { 
        @include font('060')
      }
    }
  }
}
</style>
